import { render, staticRenderFns } from "./NotaExplicativaPC.vue?vue&type=template&id=cf6b6c14"
import script from "./NotaExplicativaPC.vue?vue&type=script&lang=js"
export * from "./NotaExplicativaPC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports